import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { useBiLogger } from '../hooks/useBiLogger';
export const withLogBiEvent = (Component)=>{
    const ComponentWithLogBiEvent = (props)=>{
        const logBiEvent = useBiLogger();
        return /*#__PURE__*/ React.createElement(Component, _extends({}, props, {
            logBiEvent: logBiEvent
        }));
    };
    ComponentWithLogBiEvent.displayName = `WithLogBiEvent(${Component.displayName || Component.name || 'Component'})`;
    return ComponentWithLogBiEvent;
};
export default withLogBiEvent;
